// Styles
require("./modaal.scss");

// jQuery
// 
// Must be instanciated before requiring
// jquery-validation
//
var $ = jQuery = require('jquery');

// Modaal
//
require("./modaal.min.js");


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/modaal/index.js
// module id = 16
// module chunks = 0